export function calcBackgroundSize() {
    var w = window.innerWidth;
    var numIconsWidth = w / 40;

    var h = window.innerHeight;
    var numIconsHeight = h / 45;

    return { numIconsHeight, numIconsWidth };
}

export function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min);
}
